module.exports = __webpack_public_path__ + "img/expert3.a9c48f45.png";